module.exports = __webpack_public_path__ + "static/media/titleLeft.b372ac98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/detail/images/titleLeft.svg
// module id = 742
// module chunks = 0